/** Strip non-digits from a phone string. */
export const normalizePhone = (phone?: string | null) =>
    (phone || '').replace(/\D/g, '')

/**
 * Reduce a phone to a comparable local form (last 9 digits),
 * stripping a leading Senegal country code when present.
 */
export const toComparablePhone = (phone: string) => {
    const digits = normalizePhone(phone)
    if (!digits) return ''
    if (digits.startsWith('221') && digits.length > 9) {
        return digits.slice(3)
    }
    return digits.length > 9 ? digits.slice(-9) : digits
}

/** Display formatting for Senegal local numbers: "XX XXX XX XX" (e.g. "77 123 45 67"). */
export const formatPhone = (phone: string) => {
    const digits = toComparablePhone(phone)
    if (!digits) return ''
    const [, ...groups] =
        /^(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/.exec(digits) || []
    return groups.filter(Boolean).join(' ')
}

/** Bulk-enrollment local phone validity: exactly 9 digits. */
export const isValidSenegalPhone = (phone: string) =>
    normalizePhone(phone).length === 9

/** Fuzzy digit-sequence matcher used for client phone suggestions. */
export const buildPhoneMatchRegex = (digits: string) => {
    const fuzzyPattern = digits.split('').join('.*')
    return new RegExp(fuzzyPattern, 'i')
}
